import { useCallback, useEffect, useState } from 'react'

import { getElementWidthWithoutPadding } from '../utils/getElementWidthWithoutPadding'

export const useScrollingAreaDimensions = () => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const [horizontalScrollingArea, setHorizontalScrollingArea] = useState<HTMLDivElement | null>(
    null
  )

  const setHorizontalScrollingAreaRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      setHorizontalScrollingArea(node)
    }
  }, [])

  useEffect(() => {
    const calculateDimensions = () => {
      if (horizontalScrollingArea) {
        const width = getElementWidthWithoutPadding(horizontalScrollingArea)
        const rect = horizontalScrollingArea.getBoundingClientRect()
        const height = window.innerHeight - rect.top

        setDimensions({ width, height })
      }
    }

    const resizeObserver = new ResizeObserver(calculateDimensions)

    if (horizontalScrollingArea) {
      calculateDimensions()
      resizeObserver.observe(horizontalScrollingArea)
    }

    return () => {
      if (horizontalScrollingArea) {
        resizeObserver.disconnect()
      }
    }
  }, [horizontalScrollingArea])

  return {
    setHorizontalScrollingAreaRef,
    horizontalScrollingArea,
    dimensions,
  }
}
